import { render, staticRenderFns } from "./replaceLogo.vue?vue&type=template&id=39bd5b46&scoped=true"
import script from "./replaceLogo.vue?vue&type=script&lang=js"
export * from "./replaceLogo.vue?vue&type=script&lang=js"
import style0 from "./replaceLogo.vue?vue&type=style&index=0&id=39bd5b46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39bd5b46",
  null
  
)

export default component.exports